import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=1ab12c68"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports